module.exports = __webpack_public_path__ + "media/Mitos_realidades.6e8d09f3.wav";